import { PText } from '@porsche-design-system/components-react';
import { type ReactNode } from 'react';
import styled from 'styled-components';

const StyledTextWrapper = styled.div`
    font-size: 16px;
    height: 54px;
    padding: 8px 16px;
    border: 2px solid rgb(107, 109, 112);
    border-radius: 4px;
    outline: 0px;
    display: flex;
    align-items: center;
    cursor: pointer;
`;

const ClickableDisplayField = (props: { children: ReactNode }) => (
    <StyledTextWrapper className="porsche-v3-calculator-clickable-display-field-wrapper">
        <PText {...props} color="inherit" style={{ color: 'var(--ant-primary-color)' }} />
    </StyledTextWrapper>
);

export default ClickableDisplayField;
